import { ChangeDetectorRef, Component } from '@angular/core';
import { CmsBannerComponent ,BaseSiteService} from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { BehaviorSubject, debounceTime, distinctUntilChanged, filter, Observable, take } from 'rxjs';
import { UserInfoService } from '../../spartacus/services/user-info.service';
import { ActivatedRoute, Router } from '@angular/router';
@Component({
    selector: 'app-my-orders-dashboard',
    templateUrl: './my-orders-dashboard.component.html',
    styleUrls: ['./my-orders-dashboard.component.scss'],
    standalone: false
})
export class MyOrdersDashboardComponent {
  constructor(public component: CmsComponentData<CmsBannerComponent>,
    public userInfoService:UserInfoService,protected baseSiteService: BaseSiteService,private cd:ChangeDetectorRef,private activatedRoute: ActivatedRoute,private router:Router) {
  }
  bannerNode: Observable<any> = this.component.data$;
  seasonData:any;
  //seasonData :Observable<any> =  this.userInfoService.getseasonDropdown();
  seasons$ = this.userInfoService.seasonValue$;
  data:any;
  currentSite :any;
  seasonvalue:any;
  enablePage: any;
  activeSeason: any;
  isLoading=false;
  parameterobj:any;
  selectedSeason(e :any){ 
    const newUrl = '/orders/my-orders';

    // Navigate to the new URL
  
    this.router.navigate([newUrl]);
    this.isLoading=true;
  
    this.userInfoService.sendstartorderseason(e.target.value);
    this.seasonvalue=e.target.value
 /* 
    const loading=<HTMLElement>document.getElementsByClassName("loading")[0];
    this.activeSeason =  e.target.value;
    loading.classList.add("show"); */
    
    this.userInfoService.sendDropdownValue((e.target as HTMLInputElement).value)
    this.userInfoService.getseasonDropdown((e.target as HTMLInputElement).value).subscribe(
      (res: any) => {
        this.seasonData = res;
        this.isLoading = false;
        this.cd.detectChanges();
      },
      (error) => {
        console.error('Error fetching season dropdown data:', error);
        this.isLoading = false;
        this.cd.detectChanges();
      }
    );
    
  
    
   console.log('event', (e.target as HTMLInputElement).value)
  }
 
    
    
  
  ngOnInit(){
    const obj = {
      showukOrdersLeftSection: true,
      showukOrdersBanner: true,
      showukCartBanner: false,
      showukCartReviewSection: false,
    }
    this.baseSiteService.getActive().subscribe(res => {
      this.currentSite = res;
      
    });

    //if null default season should be peaked changes needs to be done both side
    this.userInfoService.setEnablePage(obj);
    this.userInfoService.getEnablePage().pipe(distinctUntilChanged()).subscribe((data: any) => {
      this.enablePage = data;
    })
    
      if(this.currentSite !='seqirusb2b-uk') {
        this.activatedRoute.queryParams.subscribe(res => {   
          this.parameterobj=res
          if( this.parameterobj?.address) {
            if(this.parameterobj.season){
              this.userInfoService.getseasonDropdown(this.parameterobj.season).subscribe(data=>{
                this.seasonData=data;
                this.cd.detectChanges();
                this.userInfoService.sendDropdownValue(this.parameterobj.season);
              }); 

            }else{
              let newObject = { ...this.parameterobj };
           newObject['season'] = " "
           
                this.parameterobj = newObject;
              
            
              this.userInfoService.getseasonDropdown(this.parameterobj.season).subscribe(data=>{
                this.seasonData=data;
                this.cd.detectChanges();
                 //setting season based on data from backend
                 this.parameterobj.season = this.seasonData.preSeason?this.seasonData.preSeason:this.seasonData.inSeason;
                
                //hard code needs to be remove from this by default season attr which will get from backend
                this.userInfoService.sendDropdownValue(this.parameterobj.season);
              });
            }
          }else{
            
         
        this.userInfoService.getseasonDropdown(" ").pipe(distinctUntilChanged()).subscribe(data=>{
          this.seasonData=data;
          this.cd.detectChanges();
          let newObject = { ...this.parameterobj };
          newObject['season'] = this.seasonData.preSeason?this.seasonData.preSeason:this.seasonData.inSeason;
          this.parameterobj = newObject;
          //hard code needs to be remove from this by default season attr which will get from backend
          this.userInfoService.sendDropdownValue(this.parameterobj.season);
        });
      }
    });
      }
      else {

        this.activatedRoute.queryParams
     
.pipe(
  debounceTime(0),   // ✅ wait for final emission
  take(1)
)

        .subscribe(res => { 
          this.parameterobj=res
          
       
          if(this.parameterobj.season){
            this.userInfoService.getseasonDropdown(this.parameterobj.season).pipe(take(1)).subscribe(data=>{
              this.seasonData=data;
              this.cd.detectChanges();
              this.userInfoService.sendDropdownValue(this.parameterobj.season);
            }); 
            this.cd.detectChanges();
            return;

          }else if(this.seasonvalue){

            this.activeSeason =this.seasonvalue;
           
            this.userInfoService.sendstartorderseason(this.seasonvalue);
           this.userInfoService.sendDropdownValue(this.seasonvalue);
           return;
          }
          else{
            this.userInfoService.getseasonDropdown(" ").pipe(take(1)).subscribe(data=>{
              this.seasonData=data;
              
              this.cd.detectChanges();
              let newObject = { ...this.parameterobj };
              newObject['season'] = this.seasonData?.defaultSeason
              
                   this.parameterobj = newObject;
                 
               this.activeSeason =this.seasonData?.defaultSeason;
               this.userInfoService.sendstartorderseason(this.seasonData?.defaultSeason);
              //hard code needs to be remove from this by default season attr which will get from backend
              this.userInfoService.sendDropdownValue(this.seasonData.defaultSeason);
            });
          }
        });

       
      }
      // this.userInfoService.getseasonDropdown("2025-2026").subscribe(data=>{
      //   this.seasonData=data;
      //   //hard code needs to be remove from this by default season attr which will get from backend
      //   this.userInfoService.sendDropdownValue('2025-2026');
      // });
    
   
   this.cd.detectChanges();
  }

  ngOnDestroy(){
   
 this.userInfoService.sendDropdownValue('');
 this.userInfoService.sendstartorderseason('')

  }
}
